"use strict";
import * as React from "react";
import htmlToReact from "html-react-parser";
import { TransitionGroup, CSSTransition } from "react-transition-group";

const Thumbnail = ({ imageData, openGallery }) => (
  <div
    className="entry"
    data-toggle="modal"
    data-target="#myModal"
    onClick={() => openGallery(imageData.imageindex)}
  >
    <CSSTransition in classNames="fade" timeout={500} appear={true}>
      <img
        src={`/img/${imageData.imageid}/${imageData.imgName}`}
        alt={imageData.alt}
      />
    </CSSTransition>
    <div className="overlay">
      <span>{htmlToReact(imageData.name)}</span>
    </div>
  </div>
);

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/components/Thumbnail.js